"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const Grid_1 = require("@material-ui/core/Grid");
const withStyles_1 = require("@material-ui/core/styles/withStyles");
const withTheme_1 = require("@material-ui/core/styles/withTheme");
const mediaUtil_1 = require("@pbl/pbl-react-core/lib/utils/mediaUtil");
const classnames_1 = require("classnames");
const _ = require("lodash");
const React = require("react");
const react_i18next_1 = require("react-i18next");
const react_player_1 = require("react-player");
const AppSpinner_1 = require("../app-spinner/AppSpinner");
const BonusPoints_1 = require("../bonus-points/BonusPoints");
const assets_1 = require("../config/assets");
const config_1 = require("../config/config");
const InformationDialog_1 = require("../dialog/InformationDialog");
const LoadError_1 = require("../load-error/LoadError");
const ReadMore_1 = require("../read-more/ReadMore");
const SignInWarningMessage_1 = require("../warning-message/SignInWarningMessage");
const InteractiveGameStyle_1 = require("./jss/InteractiveGameStyle");
const VideoModal_1 = require("./VideoModal");
const INITIAL_STATE = {
    launchGame: false,
    loading: false,
    gameCompleted: false,
    isPortrait: false,
    gameType: 'prize',
    launchVideo: false,
    videoPlaying: false
};
class InteractiveGame extends React.Component {
    constructor(props) {
        super(props);
        this.orientationChange = () => {
            this.setState({ isPortrait: true });
        };
        this.onCloseGame = () => {
            this.setState({ launchGame: false });
        };
        this.onOpenGame = (gameType) => {
            this.setState({ launchGame: true, loading: true, gameType }, () => {
                this.orientationChange();
            });
            this.props.getGameData(gameType);
            this.registerGame();
        };
        this.registerGame = () => {
            window.addEventListener('message', this.receiveMessage, false);
        };
        this.receiveMessage = async (event) => {
            try {
                const data = JSON.parse(event.data);
                if (!data || data.type !== 'poGame')
                    return;
                const gameData = {
                    points: this.props.gamePoints,
                    message: this.props.gameMessage ? this.props.gameMessage : '',
                    spinResults: this.props.spinResults ? this.props.spinResults : null,
                    type: this.props.gameType ? this.props.gameType : '',
                    gameFace: this.props.gameFace,
                    gameConfig: this.props.gameConfig,
                    hideExitButtons: this.props.gameConfig && this.props.gameConfig.hasOwnProperty('hideExitButtons')
                        ? this.props.gameConfig.hideExitButtons
                        : true
                };
                switch (data.name) {
                    case 'onGamePauseHandler': {
                        if (this.props.onGamePauseHandler)
                            this.props.onGamePauseHandler();
                        return console.warn('***** onGamePauseHandler');
                    }
                    case 'onGameResumeHandler': {
                        if (this.props.onGameResumeHandler)
                            this.props.onGameResumeHandler();
                        return console.warn('***** onGameResumeHandler');
                    }
                    case 'onGameResultHandler': {
                        if (this.props.onGameResultHandler)
                            this.props.onGameResultHandler(data.data);
                        return console.warn('***** onGameResultHandler ', data.data);
                    }
                    case 'onGameReplayHandler': {
                        this.setState({ loading: true });
                        if (this.props.onGameReplayHandler)
                            await this.props.onGameReplayHandler();
                        this.setState({ loading: false });
                        document.getElementById('iframe').contentWindow.postMessage(JSON.stringify({
                            type: 'poGameParent',
                            name: 'setGameConfig',
                            data: gameData
                        }), '*');
                        return console.warn('***** onGameReplayHandler');
                    }
                    case 'onGameStartHandler': {
                        if (this.props.onGameStartHandler)
                            this.props.onGameStartHandler();
                        return console.warn('***** onGameStartHandler');
                    }
                    case 'onGameReadyHandler': {
                        if (this.props.onGameReadyHandler)
                            this.props.onGameReadyHandler();
                        document.getElementById('iframe').contentWindow.postMessage(JSON.stringify({
                            type: 'poGameParent',
                            name: 'setGameConfig',
                            data: gameData
                        }), '*');
                        return console.warn('***** onGameReadyHandler');
                    }
                    case 'onGameEndHandler': {
                        if (this.props.onGameEndHandler)
                            await this.props.onGameEndHandler();
                        this.setState({ gameCompleted: true });
                        return console.warn('***** onGameEndHandler');
                    }
                    case 'onGameExitHandler': {
                        if (this.props.onGameExitHandler)
                            await this.props.onGameExitHandler();
                        this.onCloseGame();
                        return console.warn('***** onGameExitHandler');
                    }
                    case 'onGameErrorHandler': {
                        if (this.props.onGameErrorHandler)
                            this.props.onGameErrorHandler(data.data);
                        return console.warn('***** onGameErrorHandler ', data.data);
                    }
                    default:
                        return;
                }
            }
            catch (_a) { }
        };
        this.renderGameDataDescription = () => {
            const { classes, selectedUserActivity, playForPointsActivity, isLoggedIn } = this.props;
            const isDisabledPlayPoint = !(playForPointsActivity &&
                playForPointsActivity.freq_cap !== null &&
                playForPointsActivity.user_num_completions !== null &&
                playForPointsActivity.freq_cap > playForPointsActivity.user_num_completions) && isLoggedIn;
            const isPlayForFunWithPoints = selectedUserActivity &&
                selectedUserActivity.extra_data &&
                selectedUserActivity.extra_data.is_play_for_fun &&
                selectedUserActivity.extra_data.is_play_for_fun === 'true';
            const isPlayForFunOnly = selectedUserActivity &&
                selectedUserActivity.extra_data &&
                selectedUserActivity.extra_data.is_play_for_fun_only &&
                selectedUserActivity.extra_data.is_play_for_fun_only === 'true';
            const getReadMoreContext = () => {
                var _a;
                if (!selectedUserActivity) {
                    return '';
                }
                if ((_a = selectedUserActivity.extra_data) === null || _a === void 0 ? void 0 : _a.additionalInformation) {
                    return selectedUserActivity.extra_data.additionalInformation;
                }
                return _.unescape(selectedUserActivity.description);
            };
            return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: { display: 'flex', flexDirection: 'column', width: 'inherit' } }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.spacing }, { children: (0, jsx_runtime_1.jsx)(ReadMore_1.default, { context: getReadMoreContext() }) })), this.props.showSignInWarning && ((0, jsx_runtime_1.jsx)(SignInWarningMessage_1.default, { onClick: this.props.getGameData, text: this.props.signInWarningText })), this.renderPlayForFunButtons(isDisabledPlayPoint, isPlayForFunWithPoints, isPlayForFunOnly)] })));
        };
        this.renderPlayForFunButtons = (isDisabledPlayPoint, isPlayForFunWithPoints, isPlayForFunOnly) => {
            const { classes, refreshing } = this.props;
            if (isPlayForFunWithPoints || isPlayForFunOnly) {
                return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.spacing }, { children: [isPlayForFunWithPoints && ((0, jsx_runtime_1.jsx)(core_1.Button, Object.assign({ id: "btnPlayPoint", variant: "contained", disabled: this.props.showSignInWarning || refreshing || isDisabledPlayPoint, color: config_1.config.internalConfig.BUTTON_BACKGROUND, onClick: this.onOpenGame.bind(this, 'prize'), className: (0, classnames_1.default)(classes.button, 'containedButton') }, { children: "Play for Points" }))), (0, jsx_runtime_1.jsx)(core_1.Button, Object.assign({ id: "btnPlayFun", disabled: this.props.showSignInWarning || refreshing, variant: "contained", color: config_1.config.internalConfig.BUTTON_BACKGROUND, onClick: this.onOpenGame.bind(this, 'fun'), className: (0, classnames_1.default)(classes.button, 'containedButton') }, { children: "Play for Fun" }))] })));
            }
            return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.spacing }, { children: (0, jsx_runtime_1.jsx)(core_1.Button, Object.assign({ id: "btnPlayGame", disabled: this.props.showSignInWarning || refreshing, variant: "contained", color: config_1.config.internalConfig.BUTTON_BACKGROUND, onClick: this.onOpenGame.bind(this, 'prize'), className: (0, classnames_1.default)(classes.button, 'containedButton') }, { children: "Play Game" })) })));
        };
        this.hideSpinner = () => {
            this.setState({
                loading: false
            });
        };
        this.renderLimitReached = () => ((0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: 'subtitle1', color: 'error' }, { children: this.props.t('error.gameTicketEntry.ticketEntry.ticketClosed') })));
        this.renderIframe = () => {
            const { classes, selectedUserActivity } = this.props;
            const { isPortrait } = this.state;
            if (isPortrait) {
                return ((0, jsx_runtime_1.jsx)("iframe", { src: this.props.gameUrl, allow: "autoplay", scrolling: "no", id: 'iframe', className: classes.iframe, onLoad: this.hideSpinner, title: selectedUserActivity ? selectedUserActivity.activity_id : 1 }));
            }
            return ((0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: 'subtitle1', color: 'error' }, { children: this.props.t('error.interactiveGame.onlyPortraitMode') })));
        };
        this.renderLoadAgain = () => {
            const { loading } = this.state;
            if (loading) {
                this.hideSpinner();
            }
            return ((0, jsx_runtime_1.jsx)(LoadError_1.default, { onReloadIconPress: this.props.getGameData, text: 'Error loading a game. Please try again.' }));
        };
        this.startVideo = () => {
            const { selectedUserActivity } = this.props;
            if (!!selectedUserActivity &&
                !!selectedUserActivity.extra_data &&
                !!selectedUserActivity.extra_data.preview_url) {
                this.setState({ launchVideo: true });
            }
        };
        this.closeVideo = () => {
            this.setState({ launchVideo: false });
        };
        this.playVideo = () => {
            this.setState({ videoPlaying: true });
        };
        this.pauseVideo = () => {
            this.setState({ videoPlaying: false });
        };
        this.state = Object.assign({}, INITIAL_STATE);
        window.addEventListener('orientationchange', this.orientationChange);
    }
    componentWillUnmount() {
        window.removeEventListener('message', this.receiveMessage);
        window.removeEventListener('orientationchange', this.orientationChange);
    }
    render() {
        if (!this.props.selectedUserActivity)
            return null;
        const { classes, theme, selectedUserActivity, limitReached, t } = this.props;
        const { videoPlaying } = this.state;
        const baseUri = !!config_1.config.internalConfig.BASE_URL ? config_1.config.internalConfig.BASE_URL : '';
        const image = !!selectedUserActivity.image
            ? (0, mediaUtil_1.createMediaURL)(baseUri, config_1.config.internalConfig.MEDIA_API, selectedUserActivity.image)
            : assets_1.assets.internalAssets.noImage;
        const previewUrl = !!selectedUserActivity &&
            !!selectedUserActivity.extra_data &&
            !!selectedUserActivity.extra_data.preview_url
            ? selectedUserActivity.extra_data.preview_url
            : undefined;
        const videoUrl = !!selectedUserActivity &&
            !!selectedUserActivity.extra_data &&
            !!selectedUserActivity.extra_data.video_url
            ? selectedUserActivity.extra_data.video_url
            : undefined;
        return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsxs)(InformationDialog_1.default, Object.assign({ open: this.state.launchGame, hideButton: true, onClose: this.onCloseGame, maxWidth: 'lg', noSpaces: true, gameView: true, portraitMode: this.props.portraitMode, disableBackdropClick: true, reducedWidth: true }, { children: [this.state.loading ? (0, jsx_runtime_1.jsx)(AppSpinner_1.default, { label: 'Loading Game...' }) : null, !this.props.gamePoints ? this.renderLoadAgain() : this.renderIframe()] })), (0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ container: true, item: true, xs: 12, justify: 'center', className: classes.header }, { children: [this.props.renderTitle(), (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 12, style: { paddingTop: theme.spacing(4) } }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.details }, { children: [(0, jsx_runtime_1.jsxs)(core_1.Card, Object.assign({ className: classes.imageCard }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.parentDiv }, { children: [!!videoUrl ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, classnames_1.default)({
                                                            [classes.headerImage]: true,
                                                            [classes.overlay40]: !!previewUrl
                                                        }) }, { children: (0, jsx_runtime_1.jsx)(react_player_1.default, { playing: videoPlaying, controls: true, width: '100%', height: '100%', url: videoUrl, onPlay: this.playVideo, onPause: this.pauseVideo }) }))) : ((0, jsx_runtime_1.jsx)(core_1.CardMedia, Object.assign({ image: image, className: (0, classnames_1.default)({
                                                            [classes.headerImage]: true,
                                                            [classes.overlay40]: !!previewUrl
                                                        }) }, { children: this.props.bonusPoints && this.props.bonusPoints > 0 ? ((0, jsx_runtime_1.jsx)(BonusPoints_1.default, {})) : null }))), !!previewUrl && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("img", { src: assets_1.assets.internalAssets.playLogo, color: config_1.config.internalConfig.BUTTON_BACKGROUND, onClick: this.startVideo, className: classes.playIcon, alt: "Play Logo" }), (0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "h6", className: classes.previewText }, { children: t('reward.watchVideo', 'Watch Video') }))] }))] })), (0, jsx_runtime_1.jsx)(VideoModal_1.default, { launchVideo: this.state.launchVideo, videoUrl: previewUrl, onClose: this.closeVideo })] })), limitReached ? this.renderLimitReached() : this.renderGameDataDescription()] })) }))] }))] }));
    }
}
exports.default = (0, withTheme_1.default)((0, withStyles_1.default)(InteractiveGameStyle_1.default)((0, react_i18next_1.withTranslation)()(InteractiveGame)));
//# sourceMappingURL=InteractiveGame.js.map